import Character from "@lss/common/src/shell/Character";


interface HoboINT {
    male: boolean;
    didSomething: number;
}

const hoboProperties: HoboINT = {
    male: false,
    didSomething: 2
}

export const hobo = new Character<HoboINT>("Hobo", hoboProperties, "#6391FFFF");
